<template>
	<div>
		<KButton
			height="34px"
			width="unset"
			font-weight="400"
			font-size="0.8125rem"
			border-radius="0.25rem"
			title="Exportar"
			margin-left="10px"
			margin-right="10px"
			:icon="{ color: '#8b83ba', size: '18px', type: 'file-text' }"
			@click="openModalExport"
		/>
		<Modal
			v-if="modalActive"
			:download-load="downloadLoad"
			title="Exportar"
			@download="filterTable($event)"
			@close="modalActive = false"
		/>
	</div>
</template>

<script>
import XlsExport from '../../../services/xls-export';
import Modal from '../modal/pedidoexport';
import global from '../../../mixins/global';
import * as ecAxios from '../../../util/ecAxios';
import KButton from '../buttons/Default';

export default {
	components: {
		Modal,
		KButton,
	},
	mixins: [global],
	data() {
		return {
			filters: JSON.parse(localStorage.getItem('filter-users')),
			modalActive: false,
			isLoading: true,
			downloadLoad: false,
			dados: [],
			empresa_id: null,
			formpgto_id: null,
			searchTerm: null,
			situacao: null,
			situacoeslog: null,
			pessoa_id: null,
			orderby: null,
			direction: null,
			situacaoDesc: {
				0: 'Salvo',
				1: 'Finalizado',
				2: 'Integrado',
				3: 'Inválido',
				4: 'Em Análise',
				5: 'Liberado',
				6: 'Faturado',
				7: 'Cancelado',
				8: 'Transporte',
				9: 'Entregue',
				10: 'Aguardando Pagamento',
				11: 'Em rota',
			},
		};
	},
	watch: {
		modalActive() {
			this.filters = JSON.parse(localStorage.getItem('filter-users'));
		},
	},
	methods: {
		openModalExport() {
			this.modalActive = true;
		},
		async filterTable(modalData) {
			this.downloadLoad = true;
			if (this.filters.status === '2') {
				this.filters.status = null;
			}
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/users/pessoas`, this.filters)
				.then((response) => {
					if (response) {
						const { usuarios } = response.data;
						this.dados = usuarios;
						if (usuarios.length > 0) {
							this.exportExel(modalData, true);
						} else {
							this.$buefy.notification.open({
								message: 'Não existem dados neste periodo',
								type: 'is-warning',
							});
						}
					}
				})
				.catch((e) => {
					this.isloading = false;
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
		verifyStatusRow(status) {
			if (status === 1) {
				return 'Ativo';
			}
			if (status === 0) {
				return 'Inativo';
			}
			if (status === 2) {
				return 'Arquivado';
			}
			return '~';
		},
		getSintegraStatus(data) {
			let { sintegrastatus, receitastatus } = data;
			const sintegraId = sintegrastatus;
			sintegrastatus = parseInt(sintegrastatus, 10);
			if (sintegrastatus === 1) {
				sintegrastatus = 'Liberado';
			} else if (sintegrastatus === 0 && sintegrastatus !== '') {
				sintegrastatus = 'Bloqueado';
			} else {
				sintegrastatus = '';
			}
			if (receitastatus !== '' && receitastatus !== null) {
				if (receitastatus !== null) {
					receitastatus = `${receitastatus} (RF)`;
				}
				if (sintegrastatus) {
					sintegrastatus = `${`${sintegrastatus} / ${receitastatus}`}`;
				} else {
					sintegrastatus = receitastatus;
				}
			}
			return { sintegrastatus, sintegraId };
		},
		exportExel(data) {
			const newData = [];

			let firstIndex = false;
			this.dados.map((item) => {
				const newIndex = {
					ID: item.id,
					USUÁRIO: item.usuario,
					EMAIL: item.email,
					STATUS: item.status === 1 ? 'Ativo' : 'Inativo',
					'ID INTEGRAÇÃO': item.integracao_id,
					'DATA DE CRIAÇÃO': this.dateTimeToBrasil(item.created_at),
				};
				newData.push(newIndex);

				if (!firstIndex) {
					newData.push({
						id_usuario: 'ID Usuário',
						id_pessoa: 'ID Pessoa',
						nomerazao: 'Razão Social',
						fantasia: 'Fantasia',
						cpfcnpj: 'CPFCNPJ',
						rgie: 'RGIE',
						email: 'EMAIL',
						status: 'STATUS',
						ultima_compra: 'ÚLTIMA COMPRA',
					});
					firstIndex = true;
				}
				item.pessoa.forEach((pessoa) => {
					// eslint-disable-next-line no-param-reassign
					const newPessoa = {
						id_usuario: null,
						id_pessoa: null,
						nomerazao: null,
						fantasia: null,
						cpfcnpj: null,
						rgie: null,
						email: null,
						status: null,
						ultima_compra: null,
					};
					newPessoa.id_usuario = item.id;
					newPessoa.id_pessoa = pessoa.id;
					newPessoa.fantasia = pessoa.fantasia;
					newPessoa.nomerazao = pessoa.nomerazao;
					newPessoa.cpfcnpj = this.formatCnpjCpf(pessoa.cpfcnpj);
					newPessoa.email = pessoa.email;
					newPessoa.rgie = pessoa.rgie;
					newPessoa.status = pessoa.status === 1 ? 'Ativo' : 'Inativo';
					newPessoa.ultima_compra = pessoa.ultima_compra;
					newData.push(newPessoa);
				});
				newData.push({});
				return newIndex;
			});
			let filename = '';
			const xls = new XlsExport(newData);
			if (data.nome !== '') {
				filename = `${data.nome}${data.formato}`;
			} else {
				filename = `${new Date().toLocaleString()}${data.formato}`;
			}
			switch (data.formato) {
				case '.xls':
					xls.exportToXLS(filename);
					break;
				case '.csv':
					xls.exportToCSV(filename);
					break;

				default:
					break;
			}
			this.downloadLoad = false;
		},
	},
};
</script>

<style scoped>
.container-modal-ex {
	display: flex;
	align-items: center;
}
.xlsformat {
	cursor: pointer;
}
.xlsformat {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 30px;
	border: 1px solid #cececea9;
}
.btncancel {
	margin-top: 20px;
	height: 40px;
	margin-right: 15px;
}
.btn-export {
	cursor: pointer;
}
</style>

